// #region imports

// --- Angular
import {
  Component,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  HostListener,
} from '@angular/core';

// --- RxJs
import { BehaviorSubject } from 'rxjs';

// HS Code
import {
  ChartClickResponse,
  ReportRequestModel,
  ReportRequestTypes,
  ResultsStatuses,
  ResultsViews,
  SurveyResponseTypes,
  SurveyStatuses,
  SurveySummaryModel,
  TrackMyJourneyResultsModel,
} from '../../../models';

// #endregion

@Component({
  selector: 'hs-comparison-results',
  templateUrl: './comparison-results.component.html',
  styleUrls: ['./comparison-results.component.scss'],
})
export class ComparisonResultsComponent {
  @Input() selectedSurvey: SurveySummaryModel | null = null;
  @Input() compareReportResultsLoading: boolean = false;
  @Input() compareReportResults: TrackMyJourneyResultsModel[] | null = null;
  @Input() compareReportDisplayMode: ResultsViews | null = null;
  @Input() imagesRootUrl: string = '';

  responseTypes = SurveyResponseTypes;
  surveyStatuses = SurveyStatuses;
  resultsStatuses = ResultsStatuses;
  scrolled$ = new BehaviorSubject<boolean>(false);
  isClicked = false;

  @Output() chartClicked = new EventEmitter<ChartClickResponse>();
  @Output() viewChange = new EventEmitter<ResultsViews>();
  @Output() toggleCompareResultsModal = new EventEmitter<boolean>();
  @Output() filterClick = new EventEmitter<string>();
  @Output() downloadTrackMyJourneyClicked =
    new EventEmitter<ReportRequestModel>();
  @Output() openCompareResultsHint = new EventEmitter();

  constructor(private elementRef: ElementRef) {}

  onChartClick(
    responseType: SurveyResponseTypes,
    selectedSurvey: SurveySummaryModel
  ) {
    this.chartClicked.emit({
      responseType,
      selectedSurvey,
    });
  }

  onViewChange(view: ResultsViews) {
    this.viewChange.emit(view);
  }

  onToggleCompareResultsModal(show: boolean) {
    this.toggleCompareResultsModal.emit(show);
  }

  onFilterClick() {
    this.isClicked = false;
    this.filterClick.emit();
  }

  onDownloadTrackMyJourneyClicked() {
    this.isClicked = true;
    if (this.compareReportResults && this.compareReportResults.length >= 2) {
      const firstParticipantId = this.compareReportResults[0].survey.id;
      const secondParticipantId = this.compareReportResults[1].survey.id;

      const contents = new Array<string>();
      contents.push(firstParticipantId);
      contents.push(secondParticipantId);

      const model = {
        type: ReportRequestTypes.downloadTrackMyJourney,
        reportSubjectId: firstParticipantId,
        contents,
      } as ReportRequestModel;

      this.downloadTrackMyJourneyClicked.emit(model);
    }
  }

  onOpenCompareResultsHint() {
    this.openCompareResultsHint.emit();
  }

  @HostListener('scroll')
  onScroll() {
    if (this.elementRef.nativeElement.scrollTop > 1) {
      this.scrolled$.next(true);
    } else {
      this.scrolled$.next(false);
    }
  }
}
